<template>
  <!-- AI漫剧页 Banner：单图展示，无轮播 -->
  <div class="h5-banner">
    <img
      v-if="bannerImage"
      :src="bannerImage"
      alt="传智AI漫剧"
      class="banner-img"
      role="button"
      tabindex="0"
      aria-label="打开在线咨询"
      @click="handleBannerClick"
    />
  </div>
</template>

<script>
export default {
  name: "AidramaBanner",
  props: {
    bannerList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    bannerImage: function () {
      return this.bannerList.length ? this.bannerList[0].imageUrl : "";
    },
  },
  methods: {
    handleBannerClick: function () {
      var item = this.bannerList[0] || {};

      if (item.jumpUrl) {
        window.location.href = item.jumpUrl;
        return;
      }

      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI-H5-首页-banner", {
          终端: "H5",
          名称: "传智AI-H5-首页-banner",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.h5-banner {
  width: 100%;
  flex-shrink: 0;
}

.banner-img {
  display: block;
  width: 100%;
  height: auto;
  cursor: pointer;
}
</style>
